import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedResponse } from '../types';

export const useInfiniteQueryBase = <T extends PaginatedResponse>(
  queryKey: (string | undefined)[],
  fetchFunction: (pageParam: number) => Promise<T | null>,
  options: {
    enabled?: boolean;
    entityName: string;
  } = { entityName: 'data' }
): UseInfiniteQueryResult<T> => {
  return useInfiniteQuery(
    queryKey,
    async ({ pageParam = 0 }) => {
      const result = await fetchFunction(pageParam as number);
      if (!result) {
        throw new Error(`Failed to fetch ${options.entityName} page`);
      }
      return result;
    },
    {
      enabled: options.enabled,
      staleTime: 1000 * 60 * 60,
      getNextPageParam: (lastPage: T) => {
        const pagination = lastPage?.meta?.pagination;
        if (!pagination) {
          return undefined;
        }

        const hasMore = pagination.page + 1 < pagination.totalPages;
        const nextPage = hasMore ? pagination.page + 1 : undefined;

        return nextPage;
      }
    }
  );
};
